import gql from 'graphql-tag'

export const GET_VEHICLES = gql`
  query VehicleStatuses($filter: GetVehicleStatusesInput) {
    vehicleStatuses(filter: $filter) {
      message
      isSuccessful
      vehicleStatuses {
        vehicleId
        longitude
        licensePlate
        latitude
        direction
        calculatedMotionStatus
        vehicle {
          vehicleType {
            icon
          }
        }
      }
    }
  }
`

export const GET_NEAREST_VEHICLES = gql`
  query NearestVehicles($filter: GetNearestVehiclesInput!) {
    nearestVehicles(filter: $filter) {
      nearestVehicles {
        data {
          currentAddress
          distance
          formattedDistance
          fuel
          licensePlate
          vehicleId
          vehicleType {
            type
          }
        }
      }
      isSuccessful
      message
      errorName
      errorCode
      status
    }
  }
`

export const SHOW_VEHICLE = gql`
  query VehicleStatus($filter: GetVehicleStatusInput!) {
    vehicleStatus(filter: $filter) {
      errorCode
      errorName
      isSuccessful
      message
      status
      vehicleStatus {
        calculatedMotionStatus
        direction
        latitude
        longitude
        licensePlate
        motionStatus
        vehicleId
        vehicle {
          id
          vehicleType {
            icon
          }
        }
      }
    }
  }
`

export const GET_ADDRESSES = gql`
  query Geofences($filter: GetGeofencesFilter) {
    geofences(filter: $filter) {
      geofences {
        data {
          address
          geofenceId
          fenceName
          circData
          polyData
          type
        }
        pagination {
          page
          show
          total
        }
      }
      isSuccessful
      message
      status
      errorName
      errorCode
    }
  }
`

export const GET_SUMMARYTRIPS = gql`
  query SummaryTrips($filter: SummaryTripsFilter) {
    summaryTrips(filter: $filter) {
      isSuccessful
      summaryTrips {
        summaryTrips {
          stopLat
          stopLong
          stopTime
          startLat
          startLong
          startTime
          totalHourStop
        }
      }
    }
  }
`